module.exports = __webpack_public_path__ + "static/media/sdmt7.cc104673.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdmt/sdmt7.svg
// module id = 347
// module chunks = 0